import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import useFetching from "../services/cardService";
import Card from "./Card";
import CardError from "./CardError";

const CardList = () => {
  const { instance } = useMsal();
  const [cards, setCards] = useState([]);
  const [groups, setGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { getCards } = useFetching();

  async function loadCards() {
    setIsLoading(true);
    const response = await getCards();
    setCards(response.list);
    setIsLoading(false);
  }

  useEffect(() => {
    loadCards();
  }, [instance]);

  useEffect(() => {
    if (cards.length !== 0) {
      const groups = [];
      cards.forEach((card) => {
        if (!groups.includes(card.groupId)) {
          groups.push(card.groupId);
        }
      });
      groups.sort((a, b) => {
        return a - b;
      });
      setGroups(groups);
    }
  }, [cards]);

  return (
    <>
      {(() => {
        if (isLoading) {
          return (
            <div className="container-big">
              <div className="loading-spinner small"></div>
            </div>
          );
        } else if (cards.length != 0) {
          return (
            <div className="container-cards">
              {cards &&
                groups.map((group) => {
                  return (
                    <React.Fragment key={group}>
                      {groups.findIndex((temp) => temp === group) !== 0 && (
                        <div className="card-divider"></div>
                      )}
                      {cards.map((card) => {
                        if (card.groupId === group) {
                          return (
                            <Card
                              key={card.id}
                              image={card.image}
                              title={card.title}
                              description={card.description}
                              link={card.link}
                            />
                          );
                        }
                      })}
                    </React.Fragment>
                  );
                })}
            </div>
          );
        } else {
          return <CardError />;
        }
      })()}
    </>
  );
};

export default CardList;
